import { Service } from '@/services/api';
import { NotificationPreference, UserNotification } from '@/types/Notifications';
import { AxiosRequestConfig } from 'axios';

export interface GetNotificationsOptions {
  ifModifiedSince?: Date;
  limit?: number;
  offset?: number;
  unreadOnly?: boolean;
}

export interface GetNotificationsResponse {
  notifications: UserNotification[];
  total: number;
}

class NotificationService extends Service {
  async getNotifications(opts: GetNotificationsOptions = {}): Promise<GetNotificationsResponse> {
    const { ifModifiedSince, limit, offset, unreadOnly } = opts;

    const config: AxiosRequestConfig = {};
    if (ifModifiedSince) {
     config.headers = {
        'If-Modified-Since': ifModifiedSince.toUTCString(),
      };
    }

    const params: Record<string, number | boolean> = {};
    if (limit !== undefined) params.limit = limit;
    if (offset !== undefined) params.offset = offset;
    if (unreadOnly) params.unreadOnly = true;

    return this.get<GetNotificationsResponse>('/v2/notifications', params, config).then(this.handleResponse);
  }

  async markAllAsRead(): Promise<void> {
    return this.post<void>(`/v2/notifications/read`, undefined).then(this.handleResponse);
  }

  async markAsRead(id: number): Promise<void> {
    return this.post<void>(`/v2/notifications/${id}/read`, undefined).then(this.handleResponse);
  }

  async markAsUnread(id: number): Promise<void> {
    return this.post<void>(`/v2/notifications/${id}/unread`, undefined).then(this.handleResponse);
  }

  async deleteNotification(id: number): Promise<void> {
    return this.post<void>(`/v2/notifications/${id}/delete`, undefined).then(this.handleResponse);
  }

  async getPreferences(): Promise<NotificationPreference | undefined> {
    return this.get<NotificationPreference | undefined>('/v2/notifications/preferences').then(this.handleResponse);
  }

  async updatePreferences(pref: NotificationPreference): Promise<void> {
    return this.post<void>('/v2/notifications/preferences', pref).then(this.handleResponse);
  }
}

export default new NotificationService();
